import { render, staticRenderFns } from "./SelectMultipleWrapper.vue?vue&type=template&id=ed381d52&scoped=true&"
import script from "./SelectMultipleWrapper.vue?vue&type=script&lang=js&"
export * from "./SelectMultipleWrapper.vue?vue&type=script&lang=js&"
import style0 from "./SelectMultipleWrapper.vue?vue&type=style&index=0&id=ed381d52&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed381d52",
  null
  
)

export default component.exports